import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import ImagesAtelier from "./imagesAtelier"

const Atelier = ({ getOnlyFourItems }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulPageAtelier {
        edges {
          node {
            titre
            texte {
              texte
            }
          }
        }
      }
    }
  `)

  const { titre, texte } = data.allContentfulPageAtelier.edges[0].node

  return (
    <div className="block">
      <div className="block__top --special">
        <div>
          {titre && (
            <Link to="/l-atelier">
              <h2>{titre}</h2>
            </Link>
          )}
        </div>
        <div>{texte && <p className="fs-xl">{texte.texte}</p>}</div>
      </div>
      <div className="block__bottom">
        <ImagesAtelier getOnlyFourItems={getOnlyFourItems} />
      </div>
    </div>
  )
}

export default Atelier
